export interface ReportableError {
  message?: string;
  filename?: string;
  stack?: string;
}

// Errors we see constantly but can neither reproduce nor fix: a benign browser layout notification,
// and the opaque placeholder browsers use when a cross-origin script throws.
const IGNORED_MESSAGES = ['ResizeObserver loop', 'Script error.'];

// chrome-extension://, moz-extension://, safari-web-extension://, and the masked URLs WebViews and
// Safari use for injected scripts.
const FOREIGN_SCRIPT_SCHEME = /(^|[\s(@])(\w+-extension|webkit-masked-url):\/\//;

function isForeignScript(filename: string): boolean {
  try {
    return new URL(filename, window.location.href).origin !== window.location.origin;
  } catch {
    return true;
  }
}

export function shouldReportError({ message, filename, stack }: ReportableError): boolean {
  if (message && IGNORED_MESSAGES.some((ignored) => message.includes(ignored))) return false;
  if (filename && isForeignScript(filename)) return false;
  if (stack && FOREIGN_SCRIPT_SCHEME.test(stack)) return false;

  return true;
}
